export default "__VITE_ASSET__0esc7bzc__"